<template>
  <div
    v-if="UIConfig"
    id="header"
    class="header"
  >
    <head-view
      v-if="UIConfig.head"
      ref="headView"
      :config="UIConfig.head"
      :button-colors="buttonColors"
      :style="isColumnsSidebarHasConfirmation ? 'pointer-events: none;' : ''"
    />
    <tabs-view
      v-if="UIConfig.tabs && UIConfig.tabs.length"
      ref="tabsView"
      :style="isColumnsSidebarHasConfirmation ? 'pointer-events: none;' : ''"
      :config="UIConfig.tabs"
    />
    <toolbar-view
      v-if="UIConfig.toolbar"
      ref="toolbarView"
      :config="UIConfig.toolbar"
      :button-colors="buttonColors"
      :data-loaded="dataLoaded"
      :style="isColumnsSidebarHasConfirmation ? 'pointer-events: none;' : ''"
    />
  </div>
</template>

<script>
import app from '$$app';
import _ from 'lodash';
import ganttViewModel from '$$ganttViewModel';
import projectsModel from '$$projectModel';
import constants from '../../helpers/constants';
import routerHelper from '../../helpers/router';
import { checkPricingAccess } from '../../helpers/pricingHelper';
import headView from './headView.vue';
import tabsView from './tabsView.vue';
import toolbarView from './toolbarView.vue';

export default {
  name: 'HeaderVue',
  components: {
    'head-view': headView,
    'tabs-view': tabsView,
    'toolbar-view': toolbarView,
  },
  data() {
    return {
      buttonColors: {
        color: '#333333',
        labelColor: '#191919',
        activeColor: '#11519A',
        hoverBg: '#F2F2F2',
        activeBg: '#D0E0F2',
        activeHoverBg: '#A1C1E6',
      },
    };
  },
  computed: {
    UIConfig() {
      const UIConfig = this.$store.getters['headerView/UIConfig'];

      return UIConfig;
    },
    height() {
      if (this.UIConfig) {
        const mode = this.$store.getters['headerView/currentRoute'].params.mode || 'gantt';
        const specialHeight = this.UIConfig.sumHeightForTabs
          && this.UIConfig.sumHeightForTabs[mode];

        return specialHeight || this.UIConfig.sumHeight;
      }

      return 0;
    },
    currentRoute() {
      const currentRoute = this.$store.getters['headerView/currentRoute'];

      return currentRoute;
    },
    dataLoaded() {
      let isLoaded = true;
      const currentRoute = this.$store.getters['headerView/currentRoute'];

      // Required data for list view (my tasks) and workload view
      if (currentRoute.name === 'listView' || currentRoute.name === 'workload') {
        const customColumnsValuesLoaded = this.$store.getters['columns/valuesLoaded'];

        if (!customColumnsValuesLoaded) {
          isLoaded = false;
        }
      }

      return isLoaded;
    },
    isColumnsSidebarHasConfirmation() {
      return this.$store.getters.isColumnsSidebarHasConfirmation;
    },
  },
  watch: {
    currentRoute(to, from) {
      if (to.path.includes('/gantt')) {
        const projectConfig = ganttViewModel.getProjectConfig();

        this.viewSettingConfig(projectConfig);
        this.$store.commit('headerView/setOverdueTasks', projectConfig.highlight_overdue);
      }

      if (to.name !== from.name && to.name === 'projectsMultiView') {
        const viewData = ganttViewModel.getActiveViewData();

        if (viewData && viewData.name !== this.$store.getters['headerView/headTitle']) {
          this.$store.commit('headerView/setHeadTitle', viewData.name);
        }
      }
    },
    height(value) {
      const oldHeight = $$('header').config.height;

      $$('header').getNode().classList[!value ? 'add' : 'remove']('hide');

      if (value) {
        $$('header').define('height', value);
        $$('header').resize();
      }

      // if (oldHeight !== value) {
      //   gantt2.$ui.getView('ganttChart') && gantt2.$ui.getView('ganttChart').resize();
      // }
    },
  },
  beforeCreate() {
    const component = this;

    this.appListeners = [];
    this.projectsListeners = [];

    this.appListeners.push(app.on('gantt:progress:show', () => {
      component.$store.commit('headerView/setUIConfigToolbarDisable', true);
    }));

    this.appListeners.push(app.on('gantt:progress:hide', () => {
      if (!routerHelper.isTaskSettingsRoute()) {
        component.$store.commit('headerView/setUIConfigToolbarDisable', false);
      }
    }));

    this.appListeners.push(app.on('activeProject:afterSet', () => {
      component.initData();
    }));

    this.appListeners.push(app.on('activeMultiProjects:afterSet', () => {
      component.initData();
      component.$store.commit('headerView/setUIConfig');
    }));

    this.appListeners.push(app.on('init:multiview', () => {
      component.initData();
    }));

    this.appListeners.push(app.on('project:archive', (ganttId, flag) => {
      const routeParams = component.$store.getters['headerView/currentRoute'].params;

      if (+routeParams.projectId === +ganttId) {
        if (flag) {
          component.$store.dispatch('headerView/closeBulkChange');
        }

        if (flag && routeParams.mode !== 'gantt') {
          component.$store.dispatch('headerView/changeRoute', {
            name: component.$store.getters['headerView/currentRoute'].name,
            params: { mode: 'gantt' },
          });
        } else {
          component.$store.commit('headerView/setUIConfig');
        }
      }

      component.$store.commit('comments/deleteDraft', {
        projectId: ganttId,
      });
    }));

    // this.appListeners.push(app.on('gantt:reinitConfig', () => {
    //   const routeParams = component.$store.getters['headerView/currentRoute'].params;

    //   if (+routeParams.projectId) {
    //     component.$store.commit('headerView/setUIConfig');
    //   }
    // }));

    this.appListeners.push(app.on('user:changedRole', ganttId => {
      const routeParams = component.$store.getters['headerView/currentRoute'].params;

      if (+routeParams.projectId === +ganttId) {
        component.$store.dispatch('headerView/setUIConfig');
      }
    }));

    this.appListeners.push(app.on('app:route:after:changed', (to, from) => {
      component.$store.commit('headerView/setCurrentRoute', {
        name: to.name,
        path: to.path,
        params: to.params,
        prevRoute: from,
      });
      component.$store.commit('headerView/setUIConfig');
    }));

    this.projectsListeners.push(projectsModel.data.attachEvent(
      'updateProjectName',
      (ganttId, projectName) => {
        const routeParams = component.$store.getters['headerView/currentRoute'].params;

        if (+routeParams.projectId === +ganttId) {
          component.$store.commit('headerView/setHeadTitle', projectName);
        }

        this.$refs.headView?.$refs?.projectTitle?.setSelectionRange(0, 0);
      },
    ));

    this.appListeners.push(app.on('resources:model:addResourcesToProjects', data => {
      component.$store.commit('headerView/setUIConfig');
      // app.trigger('init:newProject');
      // app.trigger('gantt:reinit');
    }));

    this.appListeners.push(app.on('resources:model:removeResourcesFromProjects', (data, resourceIds) => {
      app.trigger('sideBar:update:favorite');
    }));

    this.appListeners.push(app.on('filter:status:update', value => {
      component.$store.commit('headerView/setActiveFilter', !!value);
    }));

    this.appListeners.push(app.on('masschange:enable', enable => {
      component.$store.commit('headerView/toggleBulkChange');
    }));
  },
  created() {
    this.$store.commit('headerView/setUIConfig');
    this.$store.commit('headerView/setHeight', this.height);
    // this.$emit('input', this.height);

    this.debouncedResizeHandler = _.debounce(this.resizeHandler.bind(this), 100);

    window.addEventListener('resize', this.debouncedResizeHandler);
  },
  mounted() {
    const component = this;

    component.$nextTick(() => {});
  },
  beforeUpdate() {
    this.$store.commit('headerView/setHeight', this.height);
    // this.$emit('input', this.height);
  },
  beforeUnmount() {
    document.removeEventListener('resize', this.debouncedResizeHandler);

    this.appListeners?.forEach(id => app.off(id));
    this.projectsListeners?.forEach(id => projectsModel.data.detachEvent(`${id}`));

    this.appListeners = [];
    this.projectsListeners = [];
  },
  methods: {
    checkPricingAccess,
    initData() {
      const viewData = ganttViewModel.getActiveViewData();
      const projectConfig = ganttViewModel.getProjectConfig();

      this.$store.commit('headerView/setHeadTitle', viewData ? viewData.name : '');
      this.$store.commit('headerView/setFavorite', viewData.is_favorite);
      this.viewSettingConfig(projectConfig);
      this.$store.commit('headerView/setOverdueTasks', projectConfig.highlight_overdue);
      this.$store.commit(
        'headerView/setCriticalPath',
        projectConfig.highlight_critical_path,
      );
      this.$store.dispatch('headerView/updatePublicUrlInfo');
      if (projectConfig.durationData) {
        this.$store.commit(
          'headerView/setZoom',
          constants.ZOOM.modeToZoomValue[projectConfig.durationData.mode],
        );
      }
    },
    viewSettingConfig(projectConfig) {
      if (projectConfig.right_side_text === true) {
        projectConfig.right_side_text = 'rightSideText';
      } else if (
        projectConfig.right_side_text === false
        || projectConfig.right_side_text === undefined
      ) {
        projectConfig.right_side_text = 'insideText';
      }
      if (projectConfig.cross_out_tasks === undefined) {
        projectConfig.cross_out_tasks = true;
      }
      if (projectConfig.discoloration_tasks === undefined) {
        projectConfig.discoloration_tasks = true;
      }

      this.$store.commit('headerView/setViewSettings', {
        taskName: projectConfig.right_side_text,
        completedTask: [
          projectConfig.cross_out_tasks && 'crossOutTasks',
          projectConfig.discoloration_tasks && 'discolorationTasks',
        ].filter(el => el),
        todayMarker: projectConfig.current_day_marker,
        avatar: projectConfig.show_resource_avatar,
        skipOffTime: !projectConfig.skip_off_time,
        buttons:
          projectConfig.show_advanced_buttons === undefined
            ? true
            : projectConfig.show_advanced_buttons,
        displayDays: projectConfig.show_days_on_chart === undefined
          ? false
          : projectConfig.show_days_on_chart,
        skins: +projectConfig.userSkin || 4,
        viewMode: projectConfig.view_mode,
      });
    },
    resizeHandler() {
      if (this.$refs.headView) {
        this.$refs.headView.setInputWidth();
      }
    },
  },
};
</script>

<style src="./less/main.less" lang="less"></style>
